module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/tiers/tier-detail/tier-detail.component.css
// module id = ./src/app/tiers/tier-detail/tier-detail.component.css
// module chunks = main